<template>
  <div class="otto-login">
    <Logo class="otto-login__title" />
    <div class="otto-password__reset"  v-if="!this.hasSent">
      <p class="otto-login__subtitle">RESET PASSWORD</p>
      <p class="otto-password__copy">Enter your email associated with the account, and we'll send a password reset link.</p>
      <form class="otto-login__form" v-on:submit.prevent="onSubmit">
        <p v-if="this.errorMsg" class="otto-text-error">{{errorMsg}}</p>
        <div class="otto-login__field">
          <label class="otto-login__label">EMAIL *</label>
          <input
            class="otto-login__input"
            type="text"
            v-model="email"
            @focus="onEmailFocus()"
            v-bind:class="{'otto-login__input--error': $v.email.$error}">
          <span v-if="$v.email.$error" class="otto-text-error">Please provide a valid email address.</span>
        </div>
       <button :disabled="submitting" :class="{'otto-btn--disabled': submitting}" class="otto-login__btn"><span class="otto-btn-text">SEND RESET LINK</span></button>
      </form>
      <p @click="goBack" class="otto-login__forgot otto-login__forgot--back"><span class="otto-login__forgot-link">NEVERMIND, GO BACK TO LOGIN</span></p>
    </div>
    <div class="otto-password__reset-sent" v-if="this.hasSent">
      <p class="otto-login__subtitle">RESET PASSWORD LINK SENT</p>
      <p class="otto-password__copy">A password reset link has been sent to the email address you provided. <br/><br />
        If you don't see it in a couple of minutes, check your spam folder. It was sent from support@purplego.co
      </p>
      <button class="otto-login__btn" @click="goBack"><span class="otto-btn-text">BACK TO LOGIN</span></button>
    </div>
  </div>
</template>

<script>
import { required, email } from 'vuelidate/lib/validators';
import Logo from './Logo.svg';

export default {
  name: 'request_password',
  components: {
    Logo,
  },
  data() {
    return {
      hasSent: false,
      email: '',
      errorMsg: '',
      submitting: false,
    };
  },
  validations: {
    email: {
      required,
      email,
    },
  },
  methods: {
    onEmailFocus() {
      this.errorMsg = '';
      this.$v.email.$reset();
    },
    onSubmit() {
      if (this.$v.$invalid) {
        this.$v.$touch();
      } else {
        this.submitting = true;
        this.requestPassword();
      }
    },
    goBack() {
      this.$router.push('/login');
    },
    showError(err) {
      this.errorMsg = err.message || err;
    },
    requestPassword() {
      this.$store.dispatch('requestResetPassword', this.email)
        .then(() => {
          this.submitting = false;
          this.hasSent = true;
        })
        .catch((err) => {
          console.log('ERROR', err);
          this.submitting = false;
          this.showError(err);
        });
    },
  },
};
</script>

<style lang="sass" src="@/assets/styles/password.sass"></style>




// WEBPACK FOOTER //
// src/components/RequestPassword.vue